import { supabase } from '@/core/supabase/client';

/**
 * Estado de la suscripción.
 *
 * Lo calcula la base, no la interfaz. Que la pantalla decida por su cuenta si
 * el plan está vigente abriría la puerta a dos respuestas distintas para la
 * misma pregunta: la que se muestra y la que aplica al guardar. Acá sólo se
 * lee y se muestra.
 */
export type EstadoSuscripcion =
  'trialing' | 'active' | 'past_due' | 'read_only' | 'canceled' | 'sin_suscripcion';

export interface Suscripcion {
  estado: EstadoSuscripcion;
  /** La respuesta que de verdad importa: si la base va a aceptar escribir. */
  puede_escribir: boolean;
  vence_el: string | null;
  dias_restantes: number | null;
  asientos: number | null;
  asientos_ocupados: number | null;
  proveedor: string | null;
}

export async function fetchSubscription(organizationId: string): Promise<Suscripcion> {
  const { data, error } = await supabase.rpc('subscription_state', { p_org: organizationId });
  if (error) throw error;
  return data as Suscripcion;
}

/** Pide subir o bajar la cantidad de asientos del plan. */
export async function requestSeatChange(
  organizationId: string,
  asientos: number,
): Promise<{
  aplicado: boolean;
  asientos?: number;
  asientos_pedidos?: number;
  usuarios_activos?: number;
  hay_que_desactivar?: number;
  motivo?: string;
}> {
  const { data, error } = await supabase.rpc('request_seat_change', {
    p_org: organizationId,
    p_seats: asientos,
  });
  if (error) throw error;
  return data as { aplicado: boolean };
}
